if (!customElements.get('hot-spots')) {
  customElements.define(
    'hot-spots',
    class HotSpots extends HTMLElement {
      constructor() {
        super();
        this.$buttons = this.querySelectorAll('.hotspot-button');
        this.$blocks = this.querySelectorAll('.hotspot-block');
        this.$blockContainer = this.querySelector('.hotspots-content');
        if (this.$buttons.length === 0 || this.$blocks.length === 0) return;
        this.bindEvents();
      }

      bindEvents() {
        this.$buttons.forEach((btn) => {
          btn.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.showContent(btn.dataset.targetBlock);
          });
        });
        document.addEventListener('shopify:block:select', (e) => {
          const blockId = e.detail.blockId;
          this.showContent(`${blockId}`);
        });
      }

      showContent(blockId) {
        this.$blocks.forEach((block) => {
          if (block.dataset.block === blockId) {
            block.classList.add('active');
          } else {
            block.classList.remove('active');
          }
        });
      }
    },
  );
}
